import type { Asset } from '../../../types/asset.types';
import type { ImageAssetType } from '@/components/ui/carousel/carousel.types';

export function toUploadedImageAsset(
  asset: Asset,
  previewUrl: string,
  photosetUUID?: string,
): ImageAssetType {
  return {
    photoUUID: asset.photoUUID,
    assetUUID: asset.assetUUID,
    orderUUID: asset.orderUUID,
    propertyUUID: asset.propertyUUID,
    caption: asset.caption ?? '',
    // DV-3384: the backend stamps both on the upload itself (PhotoUploadServiceImpl),
    // so the card can show them the moment the photo lands in the grid instead of
    // after a reload. Same null-vs-undefined rule as toImageAsset: a null imageID
    // means "not stamped yet" and must survive as null.
    imageID: asset.imageID ?? null,
    createdAt: asset.createdAt ?? undefined,
    caches: {
      fullSize: previewUrl,
      '1920w': previewUrl,
      '830w': previewUrl,
      '300w': previewUrl,
    },
    isChecked: false,
    ...(photosetUUID ? { photosetUUID } : {}),
    ...(asset.staged ? { staged: true } : {}),
  };
}
